import { targetScreen } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'targetScreen',
  label: 'Target Screen',
  category: 'Layouts',
  image: targetScreen,
};
